// extracted by mini-css-extract-plugin
export default {"item":"RatesItem_item__n5L2V"};